import React from 'react';
import CustomSelect from '../CustomSelect/CustomSelect';
import ButtonRolesAction from '../ButtonRolesAction/ButtonRolesAction';
import './MassActions.css'; // Стили для компонента
import {ReactComponent as LoaderIcon} from '../../images/loader-icon.svg';
const MassActions = ({
  options, // Опции для выпадающего списка
  placeholder, // Плейсхолдер для выпадающего списка
  value, // Значение по умолчанию
  onSelectChange, // Обработчик изменения выбора
  onApply, // Обработчик нажатия на кнопку "Применить"
  selectClassName, // Дополнительный класс для выпадающего списка
  buttonClassName, // Дополнительный класс для кнопки
  buttonLabel = 'ПРИМЕНИТЬ', // Текст кнопки (по умолчанию "ПРИМЕНИТЬ")
  isLoadingMassActions,
}) => {
  return (
    <div className='mass-actions'>
      {/* Выпадающий список для выбора массового действия */}
      <CustomSelect
        options={options}
        placeholder={placeholder}
        value={value}
        onChange={onSelectChange}
        className={`mass-actions__select ${selectClassName || ''}`}
      />

      {/* Кнопка для применения действия */}
      <ButtonRolesAction
        isLoadingMassActions={isLoadingMassActions}
        onClick={onApply}
        className={`mass-actions__button ${buttonClassName || ''}`}
      >
        {isLoadingMassActions && <LoaderIcon />}
        <span style={{opacity: isLoadingMassActions ? '0' : '1'}}>
          {buttonLabel}
        </span>
      </ButtonRolesAction>
    </div>
  );
};

export default MassActions;
